import React from "react";
import images from "../../assets";
import { Input } from "antd";
import MessageBox from "./messagebox";

export default function MessagesComp() {
  return (
    <div className="w-full flex flex-col gap-6">
      <h2>Messages</h2>
      <div className="w-full flex-col justify-start items-center gap-4 inline-flex">
        <div className="text-basePrimary text-2xl font-semibold font-['Poppins'] leading-loose">
          Chat list
        </div>
        <div className="w-[134px] px-2 bg-[#ebedf0] rounded-lg justify-between items-center inline-flex">
          <div className="tab-container">
            <div key="1" className="tab-menu active">
              All
            </div>
            <div key="1" className="tab-menu">
              Unread
            </div>
          </div>
        </div>
        <div className="w-full self-stretch flex-col justify-start items-start gap-5 flex">
          <div className="self-stretch flex-col justify-start items-center gap-4 flex">
            <Input style={{ height: 48 }} placeholder="Enter Name" />

            <div className="self-stretch flex-col justify-start items-center gap-2 flex">
              <MessageBox
                className="bg-primary50 rounded-xl border-l-2 border-basePrimary"
                profileimg={images.userProfile2}
                activeicon={images.onlineGreenIcon}
                name="Faiza"
                message="Assalamualaikum. How are you?"
                date="06 Feb 2024"
                time="10:41 PM"
              />
              <MessageBox
                className="bg-[#f8e6ef] rounded-xl border border-primary50"
                profileimg={images.userProfile2}
                activeicon={images.onlineGreenIcon}
                name="Faiza"
                message="Assalamualaikum. How are you?"
                date="06 Feb 2024"
                time="10:41 PM"
              />
              <MessageBox
                className="bg-white rounded-xl border border-primary50"
                profileimg={images.userProfile2}
                activeicon={images.onlineGreenIcon}
                name="Faiza"
                message="Assalamualaikum. How are you?"
                date="06 Feb 2024"
                time="10:41 PM"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
